/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const KubernetesTargetAuthKubernetesTargetIamRoleAuthKindEnum = {
    IamRole: 'IamRole'
};
/**
 * Check if a given object implements the KubernetesTargetAuthKubernetesTargetIamRoleAuth interface.
 */
export function instanceOfKubernetesTargetAuthKubernetesTargetIamRoleAuth(value) {
    if (!('kind' in value) || value['kind'] === undefined)
        return false;
    return true;
}
export function KubernetesTargetAuthKubernetesTargetIamRoleAuthFromJSON(json) {
    return KubernetesTargetAuthKubernetesTargetIamRoleAuthFromJSONTyped(json, false);
}
export function KubernetesTargetAuthKubernetesTargetIamRoleAuthFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'kind': json['kind'],
    };
}
export function KubernetesTargetAuthKubernetesTargetIamRoleAuthToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'kind': value['kind'],
    };
}
